import { Box, TableCell, TableRow, Typography } from "@mui/material";
import { useCelleraTheme } from "theme/useCelleraTheme";

function EmptyMaterials() {
  const { colors } = useCelleraTheme();
  return (
    <TableRow>
      <TableCell colSpan={4} sx={{ border: "none" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "450px",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: colors.text.secondary,
              fontSize: "0.875rem",
            }}
          >
            No materials found
          </Typography>
        </Box>
      </TableCell>
    </TableRow>
  );
}

export default EmptyMaterials;
